import $ from "jquery";

export default function initializeTimelineAccordion() {
    $('.accordion-button').click(function() {
        const accordionContent = $(this).next();
        if($(this).hasClass('active') == false) {
            $(this).addClass('active');
            let iScrollHeight = accordionContent.prop("scrollHeight") + 'px';
            accordionContent.css('max-height',iScrollHeight);
        } else {
            $(this).removeClass('active');
            accordionContent.css('max-height','0');
        }
    });
}